import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  Create,
  TextInput,
  Edit,
  EditButton,
  DeleteButton,
  Delete,
  Filter,
  TabbedForm,
  FormTab,
} from 'admin-on-rest/lib/mui';

// const ProductTypeInput = (...props) => (
//   < {...props} />
// );

import Gallery from './gallery';

export const ProductFilter = (props) => (
  <Filter {...props}>
    <TextInput label="description" source="description" alwaysOn/>
  </Filter>
);

export const ProductsList = (props) => (
  <List {...props} filters={<ProductFilter />} title="Products">
    <Datagrid key={props.code}>
      <TextField source="code" />
      <TextField source="description" />
      <TextField source="price" />
      <DeleteButton/>
      <EditButton/>
    </Datagrid>
  </List>
);

export const CreateProduct = (props) => (
  <Create {...props}>
  <TabbedForm >
    <FormTab label="general">
      <TextInput source="code" />
      <TextInput source="description" />
      <TextInput source="price" />
      </FormTab>
    <FormTab label="photos">
      <Gallery source="gallery" />
      </FormTab>
        </TabbedForm>

  </Create>
);

const PostTitle = ({ record }) => {
    return <span>{record ? `${record.code}` : ''}</span>;
};

export const EditProduct = (props) => (
  <Edit title={<PostTitle />} {...props}>
  <TabbedForm >
    <FormTab label="general">
      <TextInput source="code" />
      <TextInput source="description" />
      <TextInput source="price" />
      </FormTab>
    <FormTab label="photos">
      <Gallery source="gallery" />
      </FormTab>
        </TabbedForm>
  </Edit>
);

export const DeleteProduct = (props) => <Delete {...props} />;



// WEBPACK FOOTER //
// ./src/pages/products.js